import styled from 'styled-components';

import PageHeader from '../../shared/PageHeader';
import { ContactForm } from './ContactForm';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ContactPageContent: React.FC = () => {
  return (
    <Container>
      <PageHeader description="We're here to help" title="Contact Us" />
      <ContactForm />
    </Container>
  );
};
